import { IExamFile, ExamFile } from './exam-file.model';

export interface IExamBrief {
  idExam: string;
  name: string;
  passingScore?: number | null;
  files: IExamFile[];
}

export interface ICertificate {
  idCertificate: string;
  folio: string;
  exam: IExamBrief;
  idSignHandledBy: string | null;
}

export class ExamBrief {
  idExam: string;
  name: string;
  passingScore: number | null;
  files: ExamFile[];

  constructor(data: IExamBrief) {
    this.idExam = data.idExam;
    this.name = data.name;
    this.passingScore = data.passingScore ?? null;
    this.files = (data.files ?? []).map(f => new ExamFile(f));
  }
}

export class Certificate {
  idCertificate: string;
  folio: string;
  exam: ExamBrief;
  idSignHandledBy: string | null;

  constructor(data: ICertificate) {
    this.idCertificate = data.idCertificate;
    this.folio = data.folio;
    this.exam = new ExamBrief(data.exam);
    this.idSignHandledBy = data.idSignHandledBy;
  }
}
